import React from "react";
import { Link } from "react-router-dom";
import green_switch_ea from "../assets/images/green_switch_ea.png";
import see1 from "../assets/images/see1.svg";
import see2 from "../assets/images/see2.svg";
import see3 from "../assets/images/see3.svg";
import see4 from "../assets/images/see4.svg";
import see5 from "../assets/images/see5.svg";
import form from "../assets/images/form.png";
import purpledot from '../assets/images/purple_squre_dots.b6e7dbcc.svg';
import yellowdot from '../assets/images/yellow_squre_dots.a8deef14.svg';



function EaExamPrepration() {
  return (
    <>
      <div className="overflow-hidden bg-placement-hero bg-cover w-full">
        <div className="max-w-7xl m-auto relative isolate px-6 pt-14 lg:px-8 h-[55%] md:h-[50%] lg:h-[80%] lg:mb-0 lg:pt-2 xl:pt-2">
          <img src={green_switch_ea} alt="" className="absolute object-contain inset-0 z-10 scale-75 lg:scale-[70%] -mt-14 ml-16 md:ml-32 md:-mt-32 lg:ml-52 lg:-mt-40 xl:-mt-[16rem] mt-[35px] xl:scale-[65%] xl:ml-96 2xl:ml-[22rem]" />
          <div className="mx-auto py-10 md:py-24 lg:py-48 relative z-10 text-white">
            <div className="mx-auto lg:max-w-5xl">
              <h1 className="text-left lg:text-5xl md:text-4xl text-3xl font-bold text-gray-700 lg:w-[50%] w-[90%] mb-2 lg:leading-[56px]"><span className="block">Enrolled Agent Exam</span><span className="block"> Preparation Course</span></h1>

              <div className="scale-[60%] md:scale-75 lg:scale-100 mt-5 md:mt-4 lg:mt-10 flex flex-row gap-10 -ml-24 md:-ml-28 lg:ml-0 items-start justify-start gap-x-2 lg:gap-x-6">
                <div className="box box_btn transform transition-transform duration-300 hover:scale-110" tabindex="0">
                    <Link to="https://www.kcglobed.com/contactus#EnquireForm"
                        className="relative lg:top-[33px] bg-[#fbb03b] transition duration-300 rounded-3xl bg-primary px-6 py-4 text-sm font-semibold text-gray-700 shadow-sm hover:bg-primary hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary pb-4 cursor-pointer"
                    >
                        Enquiry Now
                    </Link>
                </div>
            </div>
            </div>
          </div>
        </div>
      </div>

      <div className="relative p-4 md:p-8 lg:p-10 pt-[91px] pb-[51px]">
        <img src={purpledot} alt="purpledot" className='absolute w-[91px] left-[21px] top-[2rem]' />
        <div className="flex flex-col items-center">
          <div tabindex="0">
            <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 gap-0 p-8 mb-10 items-center xs:max-w-xl lg:max-w-6xl group h-full">
              <img src={form} alt="" className="h-50 w-30 mb-6 lg:pr-10" />
              <div className="flex flex-col lg:mr-6">
                <h2 className="font-semibold text-left text-2xl md:text-4xl text-gray-700 mb-3">
                  <span className='uppercase text-xl'>Enrolled Agent Exam</span>
                  <span className="block mt-1 mb-2" style={{ color: 'rgb(134, 53, 122)' }}>
                    IRS Special Enrollment Examination (SEE) or IRS Exam or SEE
                    Exam Preparation Courses
                  </span>
                </h2>
                <p className="text-[15px] text-base md:text-medium text-left text-dark_text">
                  Preparing for the Enrolled Agent (EA) exam is a crucial step for
                  aspiring tax professionals. The right course materials can make
                  a significant difference in your exam preparation and success.
                  Here&#39;s a detailed look at some top preparation courses for
                  the EA exam, tailored for those searching for the best options.
                </p>
              </div>
            </div>
          </div>
        </div>
        <img src={yellowdot} alt="yellowdot" className='w-[51px] absolute bottom-[2rem] right-[21px]' />
      </div>

      <div className="p-8 md:p-8 lg:p-10 bg-[#f5f9f3]">
        <div className="flex flex-col items-center">
          <h2 className="block mb-1 text-2xl md:text-4xl font-bold text-gray-700  text-center lg:mb-3">
            <span className="uppercase text-xl">Top Notch Features of</span>
          </h2>

          <h2 className="block mb-1 text-2xl md:text-4xl font-bold text-gray-700  text-center lg:mb-2">
            <span
              className="text-primary_text"
              style={{ color: "rgb(134, 53, 122)" }}
            >
              EA Preparation Courses for IRS Exam or SEE Exam
            </span>
          </h2>
          <div tabindex="0 " className="">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 max-w-4xl mt-16">
              <div
                className="box   transform transition-transform duration-300 hover:scale-110"
                tabindex="0"
              >
                <div className="relative overflow-hidden">
                  <div>
                    <div className="flex items-center h-auto lg:h-[48rem] bg-white p-6 pt-8 pb-4 lg:pb-6 rounded-3xl lg:rounded-[160px] flex-col transition  shadow-[inset_2px_3px_6px_#46464620]">
                      <div className="scale-75 md:scale-100 bg-[#3D1F73] p-3 mb-5 h-[160px] w-[160px] rounded-[100px] shadow-md flex flex-col items-center justify-center">
                        <img
                          src={see1}
                          alt="IRS Authorization"
                          className="h-20"
                        />
                      </div>
                      <div className="px-4 text-justify">
                        <p style={{color: 'rgb(134, 53, 122)'}} className="text-start font-bold text-xl pb-2">
                          Comprehensive Coverage of IRS Exam (SEE Exam)
                        </p>
                        <p className="text-start text-md font-light pb-16 text-gray-700">
                          Detailed syllabi covering all three parts of the EA
                          exams i.e. Individuals, Businesses, and Representation,
                          Practices, and Procedures with updated content to
                          reflect the latest tax laws and IRS guidelines.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="box  transform transition-transform duration-300 hover:scale-110"
                tabindex="0"
              >
                <div className="relative overflow-hidden">
                  <div>
                    <div className="flex items-center h-auto lg:h-[48rem] bg-white p-6 pt-8 pb-4 lg:pb-6 rounded-3xl lg:rounded-[160px] flex-col transition  shadow-[inset_2px_3px_6px_#46464620]">
                      <div className="scale-75 md:scale-100 bg-[#3D1F73] p-3 mb-5 h-[160px] w-[160px] rounded-[100px] shadow-md flex flex-col items-center justify-center">
                        <img
                          src={see2}
                          alt="Tax Gurus"
                          className="h-20"
                        />
                      </div>
                      <div className="px-4 text-justify">
                        <p style={{color: 'rgb(134, 53, 122)'}} className="text-start font-bold text-xl pb-2">
                          An AI Powered Learning Management Software (LMS)
                        </p>
                        <p className="text-start text-md font-light pb-16 text-gray-700">
                          Our adaptive learning technology diagnose your strengths
                          and weaknesses, learning style and learning pattern to
                          focus you on areas needing improvement. Further course
                          content includes interactive elements like quizzes,
                          flashcards, and practice exams to enhance retention and
                          understanding.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="box  transform transition-transform duration-300 hover:scale-110"
                tabindex="0"
              >
                <div className="relative overflow-hidden">
                  <div>
                    <div className="flex items-center h-auto lg:h-[48rem] bg-white p-6 pt-8 pb-4 lg:pb-6 rounded-3xl lg:rounded-[160px] flex-col transition  shadow-[inset_2px_3px_6px_#46464620]">
                      <div className="scale-75 md:scale-100 bg-[#3D1F73] p-3 mb-5 h-[160px] w-[160px] rounded-[100px] shadow-md flex flex-col items-center justify-center">
                        <img
                          src={see3} alt="Representation and Tax Troubleshooters"
                          className="h-20"
                        />
                      </div>
                      <div className="px-4 text-justify">
                        <p style={{color: 'rgb(134, 53, 122)'}} className="text-start font-bold text-xl pb-2">
                          Unlimited Mock Tests and Practice Questions
                        </p>
                        <p className="text-start text-md font-light pb-16 text-gray-700">
                          Our EA prep course for IRS Exam (SEE Exam) include
                          2,000+ MCQs with detailed explanations for each question
                          to help you understand the reasoning behind the correct
                          and incorrect answers. Further you can experience
                          unlimited mock tests to simulate with the actual test
                          environment.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col items-center">
          <div
            tabindex="0  transform transition-transform duration-300 hover:scale-110"
            className=""
          >
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-12 max-w-xl mt-8">
              <div
                className="box  transform transition-transform duration-300 hover:scale-110"
                tabindex="0"
              >
                <div className="relative overflow-hidden ">
                  <div>
                    <div className="flex items-center h-auto lg:h-[42rem] bg-white p-6 pt-8 pb-4 lg:pb-6 rounded-3xl lg:rounded-[160px] flex-col transition  shadow-[inset_2px_3px_6px_#46464620]">
                      <div className="scale-75 md:scale-100 bg-[#3D1F73] p-3 mb-5 h-[160px] w-[160px] rounded-[100px] shadow-md flex flex-col items-center justify-center">
                        <img
                          src={see4}
                          alt="Nationwide Reach"
                          className="h-20"
                        />
                      </div>
                      <div className="px-4 text-justify ">
                        <p style={{color: 'rgb(134, 53, 122)'}} className="text-start font-bold text-xl pb-2">
                          Flexible Learning Options
                        </p>
                        <p className="text-start text-md font-light pb-16 text-gray-700">
                          Online and offline resources including video lectures,
                          e-book, textbooks, MCQs and live classes. Our self-paced
                          learning material allowing you to study at your
                          convenience.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="box  transform transition-transform duration-300 hover:scale-110"
                tabindex="0"
              >
                <div className="relative overflow-hidden ">
                  <div>
                    <div className="flex items-center h-auto lg:h-[42rem] bg-white p-6 pt-8 pb-4 lg:pb-6 rounded-3xl lg:rounded-[160px] flex-col transition  shadow-[inset_2px_3px_6px_#46464620]">
                      <div className="scale-75 md:scale-100 bg-[#3D1F73] p-3 mb-5 h-[160px] w-[160px] rounded-[100px] shadow-md flex flex-col items-center justify-center">
                        <img
                          src={see5}
                          alt="Nationwide Reach"
                          className="h-20"
                        />
                      </div>
                      <div className="px-4 text-justify ">
                        <p style={{color: 'rgb(134, 53, 122)'}} className="text-start font-bold text-xl pb-2">
                        Expert Instruction
                        </p>
                        <p className="text-start text-md font-light pb-16 text-gray-700">
                        Our live classes are led by 15+ years of experienced tax professionals and educators registered with IRS. You will get free access to support and guidance from instructors through forums, live sessions, or one-on-one tutoring.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="m-auto max-w-6xl pb-20 mt-20">
        <div className=" slogan-bg items-center backdrop-blur-md bg-[#f5f9f3] p-8 lg:p-20 rounded-3xl mx-4 lg:mx-0">
          <div className="flex flex-col gap-2 md:gap-2 lg:gap-2 xl:gap-6 2xl:gap-8 text-lg rounded-xl -mt-4 text-[#7A9C6F]">
            <div className="relative overflow-hidden">
              <div className="flex flex-col gap-1">
                <p className="justify antialiased">
                  Choosing the right IRS Exam (SEE Exam) preparation course and
                  understanding the logistics of scheduling and taking your
                  Enrolled Agent (EA) exam are vital steps in becoming an IRS
                  licensed Enrolled Agent. These courses and guidelines provide
                  a solid foundation to ensure you are well- prepared and
                  confident on exam day and beyond. For comprehensive resources
                  and support, explore the offerings from the highlighted
                  preparation providers and schedule your exam with Prometric to
                  begin your journey as an Enrolled Agent.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default EaExamPrepration;
